import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CompetitionProvider } from './contexts/CompetitionContext';
import { Splash } from './components/Splash';
import { Dashboard } from './pages/Dashboard';
import { CreateCompetition } from './components/CreateRound';
import { SequenceEditor } from './components/SequenceEditor';
import { JudgeManagement } from './components/JudgeManagement';
import { JudgeAssignment } from './components/JudgeAssignment';
import { LiveController } from './components/LiveController';
import { Results } from './components/Results';
import { PublicTimer } from './components/PublicTimer';
import { PublicResults } from './components/PublicResults';
import { CompetitionDetails } from './components/CompetitionDetails';
import AdminLogin from './pages/AdminLogin';
import PrivacyPolicy from './pages/policy';
import MultiCompetitionTimer from './components/MultiCompetitionTimer';
import { GroupCompetitionTimer } from './components/GroupCompetitionTimer';
// import "./styles/globals.css";

export default function App() {
  return (
    <Router>
      <CompetitionProvider>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<AdminLogin />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/create-round" element={<CreateCompetition />} />
            <Route path="/competitiondetails" element={<CompetitionDetails />} />
            <Route path="/sequence-editor" element={<SequenceEditor />} />
            <Route path="/judge-management" element={<JudgeManagement />} />
            <Route path="/judge-assignment" element={<JudgeAssignment />} />

            <Route path="/live-controller" element={<LiveController />} />
            <Route path="/results" element={<Results />} />
            <Route path="/public/timer/:shareableId" element={<PublicTimer />} />
            <Route path="/public/results/:shareableId" element={<PublicResults />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/multi-timer" element={<MultiCompetitionTimer />} />
            <Route path="*" element={<Navigate to="/" replace />} />
            <Route path="/group-timer/:groupId" element={<GroupCompetitionTimer />} />
          </Routes>
        </div>
      </CompetitionProvider>
    </Router>
  );
}